import { PostListLoader as PostListLoaderV3 } from "@/react/components/PostsV3/PostViewList/PostListLoader";

export const LoaderWrapper = () => <PostListLoaderV3 count={10} />;
